/* =====================================================================
   Balleh — product form: variant picker, price sync, availability.
   ===================================================================== */
(function () {
  'use strict';
  const B = window.Balleh || {};
  const t = (k) => (B.strings && B.strings[k]) || k;
  const form = document.querySelector('[data-product-form][data-product-id]');
  if (!form) return;

  const productJsonEl = document.querySelector('[data-product-json]');
  if (!productJsonEl) return;
  let product;
  try { product = JSON.parse(productJsonEl.textContent); } catch (e) { return; }

  const variantInput = form.querySelector('[data-variant-id-input]');
  const optionButtons = form.querySelectorAll('[data-option-value]');
  const addBtn = form.querySelector('[data-add-to-cart]');
  const addText = form.querySelector('[data-add-text]');
  const buyBtn = form.querySelector('[data-buy-now]');
  const priceWrap = document.querySelector('.pdp__price-block');
  const mispayWidget = document.querySelector('[data-mispay-widget]');
  const tamaraWidget = document.querySelector('[data-tamara-widget]');
  const tabbyEl = document.querySelector('[data-tabby-promo]');

  // Selected option values (mirrors the active buttons)
  const selected = (product.options || []).map((_, i) => {
    const btn = form.querySelector(`[data-option-value].is-active[data-option-index="${i}"]`);
    return btn ? btn.dataset.value : null;
  });

  function findVariant() {
    return product.variants.find(v =>
      v.options.every((opt, i) => opt === selected[i])
    );
  }

  const fmtMoney = (cents) => (B.formatMoney ? B.formatMoney(cents) : ((Number(cents) || 0) / 100).toFixed(2));

  function setPrice(cents) {
    // The pinned mobile buy bar echoes the price (it's the only place a shopper can
    // see it without scrolling) — keep that copy in step too.
    const ctaPrice = document.querySelector('[data-cta-price] .price__amount, [data-cta-price]');
    if (ctaPrice && ctaPrice.firstChild) ctaPrice.firstChild.nodeValue = fmtMoney(cents) + ' ';
    if (!priceWrap) return;
    // Single-price PDP: snippets/price.liquid renders a `.price__amount` whose first
    // text node is the number — swap it in place so the SAR symbol span is preserved.
    const amountEl = priceWrap.querySelector('.price__amount');
    if (amountEl && amountEl.firstChild) {
      amountEl.firstChild.nodeValue = fmtMoney(cents) + ' ';
      return;
    }
    // price_varies PDP renders "from {min}" with no `.price__amount`; once a variant is
    // chosen we know the exact price, so build the same markup and drop the "from" copy.
    const fromEl = priceWrap.querySelector('.pdp__price');
    if (fromEl) {
      const sarUrl = B.assets && B.assets.sar_symbol_url;
      const sar = sarUrl ? `<span class="sar-symbol"><img src="${sarUrl}" alt="" width="16" height="16"></span>` : '';
      fromEl.innerHTML = `<span class="price__amount">${fmtMoney(cents)} ${sar}</span>`;
    }
  }

  // Keep the MisPay BNPL widget's amount in step with the chosen variant.
  // amount is in major units (SAR); the custom element re-reads it on change.
  function setMispayAmount(cents) {
    if (!mispayWidget) return;
    mispayWidget.setAttribute('amount', ((Number(cents) || 0) / 100).toFixed(2));
  }

  // Keep the Tamara widget's amount in step with the chosen variant, then ask
  // the SDK to re-render it — Tamara doesn't observe the attribute on its own.
  function setTamaraAmount(cents) {
    if (!tamaraWidget) return;
    tamaraWidget.setAttribute('amount', ((Number(cents) || 0) / 100).toFixed(2));
    if (window.TamaraWidgetV2 && typeof window.TamaraWidgetV2.refresh === 'function') {
      window.TamaraWidgetV2.refresh();
    }
  }

  // Tabby's promo isn't a custom element — it must be (re-)instantiated via
  // new TabbyPromo({...}) on load and whenever the variant price changes.
  function renderTabby(cents) {
    if (!tabbyEl || typeof window.TabbyPromo === 'undefined') return;
    tabbyEl.innerHTML = '';
    const cfg = {
      selector: '#' + tabbyEl.id,
      currency: tabbyEl.dataset.currency || 'SAR',
      price: ((Number(cents) || 0) / 100).toFixed(2),
      lang: tabbyEl.dataset.lang || 'en',
      source: 'product',
      shouldInheritBg: false,
      publicKey: tabbyEl.dataset.publicKey
    };
    // merchantCode is optional — Tabby uses it to pick the country/currency entity.
    if (tabbyEl.dataset.merchantCode) cfg.merchantCode = tabbyEl.dataset.merchantCode;
    new window.TabbyPromo(cfg);
  }

  function updateAvailability() {
    for (const btn of optionButtons) {
      const idx = parseInt(btn.dataset.optionIndex, 10);
      const val = btn.dataset.value;
      const tentative = selected.slice();
      tentative[idx] = val;
      const match = product.variants.find(v => v.options.every((opt, i) => i === idx ? opt === val : (selected[i] == null || opt === selected[i])));
      btn.disabled = !(match && match.available);
    }
  }

  function update() {
    const variant = findVariant();
    if (variant) {
      variantInput.value = variant.id;
      // Update URL ?variant=
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      setPrice(variant.price);
      setMispayAmount(variant.price);
      setTamaraAmount(variant.price);
      renderTabby(variant.price);

      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) addText.textContent = t(variant.available ? 'product.add_to_cart' : 'product.sold_out');
      if (buyBtn) buyBtn.hidden = !variant.available;
    } else {
      // The chosen option combination doesn't exist — never let the form submit the
      // previously selected variant behind the customer's back.
      variantInput.value = '';
      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = t('product.out_of_stock');
      if (buyBtn) buyBtn.hidden = true;
    }
    updateAvailability();
  }

  for (const btn of optionButtons) {
    btn.addEventListener('click', () => {
      const idx = parseInt(btn.dataset.optionIndex, 10);
      // Deactivate siblings, activate this one
      for (const b of form.querySelectorAll(`[data-option-value][data-option-index="${idx}"]`)) b.classList.remove('is-active');
      btn.classList.add('is-active');
      selected[idx] = btn.dataset.value;
      update();
    });
  }

  updateAvailability();
  if (tabbyEl) renderTabby(tabbyEl.dataset.priceCents);
})();
